import React from "react";

interface Props {
  readonly size?: number;
  readonly color?: string;
}
export default function DisabledIcon({ size = 24, color = "#EB5757" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="9.5" fill="white" />
      <path
        d="M2 12C2 13.9778 2.58649 15.9112 3.6853 17.5557C4.78412 19.2002 6.3459 20.4819 8.17316 21.2388C10.0004 21.9957 12.0111 22.1937 13.9509 21.8078C15.8907 21.422 17.6725 20.4696 19.0711 19.0711C20.4696 17.6725 21.422 15.8907 21.8078 13.9509C22.1937 12.0111 21.9957 10.0004 21.2388 8.17316C20.4819 6.3459 19.2002 4.78412 17.5557 3.6853C15.9112 2.58649 13.9778 2 12 2C9.34783 2 6.80429 3.05357 4.92893 4.92893C3.05357 6.80429 2 9.34783 2 12ZM18.5357 17.5357L6.46428 5.46428C8.1076 4.09643 10.2028 3.39213 12.3387 3.48962C14.4746 3.5871 16.4969 4.47934 18.0088 5.99121C19.5207 7.50309 20.4129 9.52542 20.5104 11.6613C20.6079 13.7972 19.9036 15.8924 18.5357 17.5357ZM6.45714 18.5429C4.72737 17.0739 3.65072 14.979 3.46326 12.7174C3.2758 10.4559 3.99284 8.21225 5.45714 6.47857L17.5214 18.5429C15.9744 19.85 14.0146 20.5672 11.9893 20.5672C9.96399 20.5672 8.00412 19.85 6.45714 18.5429Z"
        fill={color}
      />
    </svg>
  );
}
